import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormatVisit',
  standalone: true,
})
export class DateFormatVisitPipe implements PipeTransform {
  transform(value: number): string {
    const dateObj = new Date(value);
    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');

    return `Día ${day}/${month}/${year} a las ${hours}:${minutes}h`;
  }
}
